import React, { useState } from "react";

const NavBar = ({ homeURL }) => {
  const [isActive, setisActive] = useState(false);

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <a class="navbar-item" href={homeURL}>
          <img src="favicon.ico" width="28" height="40" />
        </a>
        <a className="-ml-4 navbar-item" href={homeURL}>
          <p className="text-blue-600 tracking-wide">Medicare Hospital</p>
        </a>
        <a
          onClick={() => {
            setisActive(!isActive);
          }}
          role="button"
          className={`navbar-burger burger ${isActive ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        id="navbarBasicExample"
        className={`navbar-menu ${isActive ? "is-active" : ""}`}
      >
        <div className="navbar-end">
          <div className="navbar-start">
            <a href="#about-us" className="text-blue-600 navbar-item">
              About Us
            </a>
            <a href="#services" className="text-blue-600 navbar-item">
              Services
            </a>
            <a href="#staff" className="text-blue-600 navbar-item">
              Staff
            </a>
            <div className="navbar-item ">
              <a
                className="button hover:shadow-lg transition-shadow hover:border-3 hover:border-white hover:border-solid text-white hover:text-white bg-main"
                target="_blank"
                href="https://www.google.com/maps/place/Medicare+Hospital,+Near+Petrol+Pump,+Marol+Naka,+Andheri+Kurla+Road,+Andheri+East,+Mumbai,+Maharashtra+400059,+India/@19.1084333,72.8777682,16z/data=!4m2!3m1!1s0x3be7c8152762c2cb:0x84d6ca6723c23313"
              >
                View on Map
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
  // <nav>
  //       <div className="brand-container p-2">
  //           <img src="" alt="" />
  //     <a href={homeURL}>Medicare Hospital</a>
  //   </div>
  // </nav>
};

export default NavBar;
